(function () {
	'use strict';

	angular
		.module('invesfleet')
		.factory('styleMapService', styleMapService);
	

	function styleMapService() {
		var service = {
			getOptionsStyleMaps: getOptionsStyleMaps,
		};

		return service;


		function getOptionsStyleMaps() {
			return {
				styles: [] //codigo generado por google
			};
		}

	}

})();